namespace TabAurous.Retail {
    export namespace GSTR1B2CSService {
        export const baseUrl = 'Retail/GSTR1B2CS';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/GSTR1B2CS/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>GSTR1B2CSService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
